import { useNavigate } from "react-router-dom";
import { weddingClients } from "../data/weddingClients";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const WeddingGallery = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-neutral-950 min-h-screen">
      <Navigation />

      <section className="py-24 lg:py-32">
        <div className="max-w-[1800px] mx-auto px-6 lg:px-12">

          {/* Header */}
          <div className="text-center mb-20">
            <span className="text-[#d4af37] text-xs tracking-[0.4em] block mb-4">
              WEDDING STORIES
            </span>
            <h1 className="text-4xl lg:text-5xl text-white font-light">
              Wedding Photography
            </h1>
          </div>

          {/* Clients Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {weddingClients.map((client, i) => (
              <div
                key={client.slug}
                onClick={() => navigate(`/gallery/wedding/${client.slug}`)}
                className="group cursor-hover relative aspect-[3/4] overflow-hidden"
                style={{ animationDelay: `${i * 0.15}s` }}
              >
                <img
                  src={client.cover}
                  alt={client.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" />

                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-end p-8">
                  <span className="text-[#d4af37] text-xs tracking-[0.3em] mb-3">
                    {client.subtitle}
                  </span>
                  <h3 className="text-2xl text-white font-serif font-light">
                    {client.name}
                  </h3>
                  <div className="h-px bg-gradient-to-r from-[#d4af37] to-transparent w-0 group-hover:w-full transition-all duration-700 mt-6" />
                </div>

                {/* Frame */}
                <div className="absolute top-4 left-4 right-4 bottom-4 border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </div>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WeddingGallery;
